import axios from "axios";
import { redux_store } from "../store";
const CLIENT_TOKEN = process.env.LETS_TRADE_CLIENT_TOKEN ?? "";
// interface IApiResponse {
//   success: boolean;
//   message: string;
//   content?: any;
// }
export const DEFAULTS = {
    PAGE: 1,
    SIZE: 10,
};
export class API {
    constructor() {
        this.configurationErrorResponse = {
            success: false,
            message: "Authentication Not Found",
            content: {},
        };
    }
    async apiGet({ baseUrl, endpoint, authorization, noAuth = false }) {
        const valid = this.validateAuthorization(authorization);
        if (!valid) {
            return this.configurationErrorResponse;
        }
        return await axios({
            method: "GET",
            url: `${baseUrl}/${endpoint}`,
            ...(noAuth === false && { headers: this.getHeader(authorization) }),
        })
            .then((response) => {
            // console.log(`api -> apiGet -> calls -> ${endpoint} SUCCESS:`, response);
            return response.data;
        })
            .catch((error) => {
            // console.log(`api -> apiGet -> calls -> ${endpoint} ERROR:`, error);
            return this.extractErrorMessage(error);
        });
    }
    async apiPost({ baseUrl, endpoint, contentType, content, authorization }) {
        const valid = this.validateAuthorization(authorization);
        if (!valid) {
            return this.configurationErrorResponse;
        }
        return await axios({
            method: "POST",
            url: `${baseUrl}/${endpoint}`,
            headers: this.getHeader(authorization),
            data: content,
        })
            .then((response) => {
            // console.log(`api -> apiPost -> calls -> ${endpoint} SUCCESS:`, response);
            return response.data;
        })
            .catch((error) => {
            // console.log(`api -> apPost -> calls -> ${endpoint} ERROR:`, error);
            return this.extractErrorMessage(error);
        });
    }
    async apiPut({ baseUrl, endpoint, contentType, content, authorization }) {
        const valid = this.validateAuthorization(authorization);
        if (!valid) {
            return this.configurationErrorResponse;
        }
        return await axios({
            method: "PUT",
            url: `${baseUrl}/${endpoint}`,
            headers: this.getHeader(authorization),
            data: content,
        })
            .then((response) => {
            // console.log(`api -> apiPut -> calls -> ${endpoint} SUCCESS:`, response);
            return response.data;
        })
            .catch((error) => {
            // console.log(`api -> apiPut -> calls -> ${endpoint} ERROR:`, error);
            return this.extractErrorMessage(error);
        });
    }
    getHeader(authorization) {
        const state = redux_store.getState();
        const userState = state.userState;
        const { token } = userState.user;
        const tokenToUse = authorization ?? token ?? CLIENT_TOKEN;
        return {
            authorization: `Bearer ${tokenToUse}`,
            "content-type": "application/json",
        };
    }
    extractErrorMessage(error) {
        let message = error;
        if (error.response) {
            // The client was given an error response (5xx, 4xx)
            // console.log("Error", error.response);
            if (error.response.status == 0) {
                message = "Client could not connect to the server";
            }
            else {
                message = "Client was given an error response";
            }
            // message = "Client was given an error response";
        }
        else if (error.request) {
            message = "Client request never left the browser and therefore never received a response from the server ";
        }
        else {
            // Anything else
            // console.log("Error", error.message);
            message = error.message;
        }
        //Simulate a normal response so that it wont break the UI.
        return {
            success: false,
            message: message,
            content: error,
        };
    }
    validateAuthorization(authorization) {
        if (!authorization && !CLIENT_TOKEN) {
            return false;
        }
        return true;
    }
}
